import { createFeatureSelector, createSelector } from '@ngrx/store';
import { companyFileSelectors } from '../reducers/company-files.reducer';

const companyFilesSelector = createFeatureSelector('companyFiles');

export const selectAllCompanyFiles = createSelector(
	companyFilesSelector,
	companyFileSelectors.selectAll,
);
